import {useEffect, useState} from 'react'
import Homepage from '../pages/Homepage';
import { useNavigate } from 'react-router-dom';

const Curtains = () => {
    const navigate = useNavigate();
    const [curtainsRevealed, setCurtainsRevealed] = useState(false);
    
    useEffect(() => {
        if (curtainsRevealed) {
        const timer = setTimeout(() => { navigate('/', {replace: true}); }, 1000);
        return () => clearTimeout(timer);
        }
    }, [curtainsRevealed]);

    return (
        <>
            <div className="curtain" onClick={()=>{setCurtainsRevealed(true)}}>
                {/* Left Curtain */}
                <div className={`curtain_panel curtain_panel_left ${curtainsRevealed? 'reveal_left': ''}`} ></div>

                {/* Content */}
                <div style={{zIndex: 1, position: 'relative'}}><Homepage/></div>

                {/* Right Curtain */}
                <div className={`curtain_panel curtain_panel_right ${curtainsRevealed? 'reveal_right': ''}`}></div>
            </div>
        </>
    )
}

export default Curtains